export const envConfigForShare = {
  prod: {
    policyServiceUrl: process.env.HEALTH_POLICY_SERVICE_URL,
    proposalServiceUrl: process.env.LIFE_PROPOSAL_SERVICE_URL,
    healthProposalServiceUrl: process.env.HEALTH_PROPOSAL_SERVICE_URL,
  },
  master: {
    policyServiceUrl: process.env.HEALTH_POLICY_SERVICE_URL,
    proposalServiceUrl: process.env.LIFE_PROPOSAL_SERVICE_URL,
    healthProposalServiceUrl: process.env.HEALTH_PROPOSAL_SERVICE_URL,
  },
  dev: {
    policyServiceUrl: process.env.HEALTH_POLICY_SERVICE_URL,
    proposalServiceUrl: process.env.LIFE_PROPOSAL_SERVICE_URL,
    healthProposalServiceUrl: process.env.HEALTH_PROPOSAL_SERVICE_URL,
  },
  local: {
    policyServiceUrl: process.env.HEALTH_POLICY_SERVICE_URL,
    proposalServiceUrl: process.env.LIFE_PROPOSAL_SERVICE_URL,
    healthProposalServiceUrl: process.env.HEALTH_PROPOSAL_SERVICE_URL,
  },
}
